import { useFetchAllShopDevices } from '@@partner:graphql/query/device/allShopDevices.gql'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import { NestedFilter } from '@@partner:types:graphql'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import DeviceAdminQRModal from '@components/device/DeviceAdminQRModal'
import DevicesFilter from '@components/device/DevicesFilter'
import DevicesTable from '@components/device/DevicesTable'
import ShopTopMenu from '@components/shop/ShopTopMenu'
import React, { useCallback, useState } from 'react'
import { AddOutline } from 'react-ionicons'
import { useParams } from 'react-router-dom'
import { FlexboxGrid, Nav, Navbar, Pagination, SelectPicker } from 'rsuite'


export default function DevicesPage () {
  const { brandSlug } = useParams<any>()

  const [ showQRModal, setShowQRModal ] = useState(false)
  const [ filter, setFilter ] = useState<NestedFilter>({
    fields: [ 'id' ],
    op: 'unwrap'
  })
  
  const {
    page,
    limit,
    defaultLimitOptions,
    tableSort,
    handlePageSelect,
    handleLimitSelect,
    handleSortColumn
  } = useGridHelper()

  const { data, loading, error } = useFetchAllShopDevices({
    pager: {
      page,
      limit
    },
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    },
    filter
  })

  const devices = data?.allShopDevices?.edges ?? []
  const pageInfo = data?.allShopDevices?.pageInfo

  const handleFilterChanged = useCallback((updatedFilter: NestedFilter) => {
    setFilter(updatedFilter)
    handlePageSelect(1)
  }, [ handlePageSelect ])

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        error={error}
        title="Ошибка загрузки устройств"
      />
    )
  }

  return (
    <div className='ShopDevicesPage'>
      <DeviceAdminQRModal 
        open={showQRModal}
        onClose={() => setShowQRModal(false)}
      />
      <h1 className='u-heading'>Устройства</h1>
      <ShopTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            onClick={() => {
              setShowQRModal(true)
            }}
          >
              Показать QR-код
          </Nav.Item>
        </Nav>
      </Navbar>
      <DevicesFilter 
        onFilterChanged={handleFilterChanged}
      />
      <DevicesTable 
        brandSlug={brandSlug}
        devices={devices}
        loading={loading}
        onSortColumn={handleSortColumn}
        tableSort={tableSort}
      />
      <FlexboxGrid
        justify="space-between"
        align="middle"
        style={{ marginTop: 10 }}
      >
        <Pagination
          last
          first
          next
          prev
          ellipsis
          activePage={page}
          pages={pageInfo?.lastPage}
          total={pageInfo?.total ?? 0}
          maxButtons={10}
          onSelect={handlePageSelect}
        />
        <SelectPicker
          value={limit}
          data={defaultLimitOptions.map((key) => ({ value: key, label: key }))}
          cleanable={false}
          searchable={false}
          onChange={handleLimitSelect}
        />
      </FlexboxGrid>
    </div>
  )

}